module.exports = __webpack_public_path__ + "media/event-access/meetup@1x-aeaa9a14.png";